// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IStateResponseDto
 */
export interface IStateResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IStateResponseDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IStateResponseDto
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof IStateResponseDto
     */
    name?: string;
}

/**
 * Check if a given object implements the IStateResponseDto interface.
 */
export function instanceOfIStateResponseDto(value: object): value is IStateResponseDto {
    return true;
}

export function IStateResponseDtoFromJSON(json: any): IStateResponseDto {
    return IStateResponseDtoFromJSONTyped(json, false);
}

export function IStateResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IStateResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'code': json['code'] == null ? undefined : json['code'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function IStateResponseDtoToJSON(json: any): IStateResponseDto {
    return IStateResponseDtoToJSONTyped(json, false);
}

export function IStateResponseDtoToJSONTyped(value?: IStateResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'name': value['name'],
    };
}

